import { Option, some, none } from "fp-ts/lib/Option";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const environment: any;

export function flexguardCalculatorUrlVariableForRef(serviceRef: string) {
    return `flexGuardCalculatorUrl_${serviceRef}`;
}

export function flexguardCalculatorUrlForRef(serviceRef: string): Option<string> {
    const varName = flexguardCalculatorUrlVariableForRef(serviceRef);
    if (varName in environment) {
        const url = environment[varName];
        if (url && url.toString().trim() !== '') {
        return some(url.toString().trim());
        } else {
            return none;
        }
    } else {
        return none;
    }
}

export function flexguardExportUrlVariableForRef(serviceRef: string) {
    return `flexGuardExportUrl_${serviceRef}`;
}

export function flexguardExportUrlForRef(serviceRef: string): Option<string> {
    const varName = flexguardExportUrlVariableForRef(serviceRef);
    if (varName in environment) {
        const url = environment[varName];
        if (url && url.toString().trim() !== '') {
        return some(url.toString().trim());
        } else {
            return none;
        }
    } else {
        return none;
    }
}


export function productCusipCodeVariableForShareClass(shareClass: string) {
    const shareClassSafe = shareClass.replace(/[^\w]/g, '');
    return `productCusip_${shareClassSafe}`;
}

export function productCusipCodeForShareClass(shareClass: string): Option<string> {
    const varName = productCusipCodeVariableForShareClass(shareClass);
    if (varName in environment) {
        const url = environment[varName];
        if (url && url.toString().trim() !== '') {
        return some(url.toString().trim());
        } else {
            return none;
        }
    } else {
        return none;
    }
}
